import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { readShellEnabled, toggleShellLayoutAndReload } from './shellFlag';

const LayoutToggle = ({ compact = false, sx }) => {
    const shellEnabled = readShellEnabled();
    const tooltip = shellEnabled
        ? 'Switch to classic 16-tab layout'
        : 'Switch to Insights 2.0 layout';

    const control = (
        <Switch
            size="small"
            checked={shellEnabled}
            onChange={toggleShellLayoutAndReload}
            inputProps={{ 'aria-label': tooltip }}
        />
    );

    const label = (
        <Typography component="span" sx={{ fontSize: compact ? '0.72rem' : '0.75rem', color: 'inherit' }}>
            Insights 2.0
        </Typography>
    );

    if (compact) {
        return (
            <Tooltip title={tooltip} placement="top">
                <FormControlLabel control={control} label={label} sx={{ m: 0, ...sx }} />
            </Tooltip>
        );
    }

    return (
        <Tooltip title={tooltip} placement="bottom">
            <FormControlLabel control={control} label={label} sx={{ m: 0, mr: 0.5, ...sx }} />
        </Tooltip>
    );
};

export default LayoutToggle;
